/* KBF catalogue enhancements. Server-side facets replace client crawl. */
(() => {
  'use strict';
  const productCards = (scope) => [...scope.querySelectorAll('.pcard[data-product-id]')];

  if (!customElements.get('kbf-collection')) {
    customElements.define('kbf-collection', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.panel = this.querySelector('[data-filter-panel]');
        this.toggle = this.querySelector('[data-filters-toggle]');
        this.status = this.querySelector('[data-catalog-status]');
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-filters-toggle]')) this.openFilters(!this.panel.open);
          if (event.target.closest('[data-filters-done]')) this.openFilters(false);
          if (event.target === this.panel) {
            const bounds = this.panel.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.openFilters(false);
          }
        }, { signal: this.controller.signal });
        this.addEventListener('change', (event) => {
          const url = event.target.closest('[data-filter-url]')?.dataset.filterUrl;
          if (!url) return;
          if (this.status) this.status.textContent = 'Updating products…';
          location.assign(url);
        }, { signal: this.controller.signal });
        this.panel.addEventListener('close', () => {
          this.toggle.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('kbf-filters-open');
          this.toggle.focus();
        }, { signal: this.controller.signal });
        this.load();
      }

      disconnectedCallback() {
        this.controller.abort();
        if (this.panel.open) { this.panel.close(); document.body.classList.remove('kbf-filters-open'); }
      }
      openFilters(open) {
        if (open) this.panel.showModal();
        else this.panel.close();
        document.body.classList.toggle('kbf-filters-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
      }

      load() {
        this.sort = this.querySelector('[data-kbf-sort]');
        if (!this.sort) return;
        const currentURL = new URL(location.href);
        this.sort.value = ['price-ascending', 'price-descending'].includes(currentURL.searchParams.get('sort_by')) ? currentURL.searchParams.get('sort_by') : 'manual';
        this.page = 1;
        this.pageSize = Number(this.dataset.pageSize) || 24;
        this.ready = true;
        this.toggle.hidden = false;
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-kbf-sort]')) return;
          this.paint();
        }, { signal: this.controller.signal });
        this.paint(); this.status.textContent = '';
      }

      paint() {
        const pages = Math.max(1, Math.ceil(productCards(this).length / this.pageSize));
        this.page = Math.max(1, Math.min(this.page, pages));
        const productGrid = this.querySelector('#product-grid');
        if (productGrid) productGrid.replaceChildren(...productCards(this).slice((this.page - 1) * this.pageSize, this.page * this.pageSize));
        const pagination = this.querySelector('[data-kbf-pagination]');
        if (!pagination) return;
        pagination.replaceChildren(); pagination.hidden = pages === 1;
        const go = (text, page, disabled) => {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = text; button.disabled = disabled;
          button.addEventListener('click', () => {
            this.page = page; this.paint();
            const toolbar = this.querySelector('.toolbar');
            if (toolbar) toolbar.scrollIntoView({ block: 'start' });
            this.toggle.focus({ preventScroll: true });
          });
          return button;
        };
        const pageLabel = document.createElement('span'); pageLabel.textContent = `Page ${this.page} of ${pages}`;
        pagination.append(go('Previous', this.page - 1, this.page === 1), pageLabel, go('Next', this.page + 1, this.page === pages));
      }
    });
  }

  if (!customElements.get('kbf-xsell')) {
    customElements.define('kbf-xsell', class extends HTMLElement {
      connectedCallback() { this.controller = new AbortController(); }
      disconnectedCallback() { this.controller.abort(); }
    });
  }

  // PDP gallery: thumbnails swap the main photo (owner 2026-09-29 — extra photos never showed).
  if (!window.kbfGalleryUI) {
    window.kbfGalleryUI = true;
    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('.kbf-thumb');
      if (!thumb) return;
      const gallery = thumb.closest('[data-kbf-gallery]');
      const img = gallery?.querySelector('[data-kbf-product-image] img');
      if (!img) return;
      img.srcset = thumb.dataset.srcset;
      img.src = thumb.dataset.src;
      gallery.querySelectorAll('.kbf-thumb').forEach((t) => t.setAttribute('aria-pressed', String(t === thumb)));
    });
  }

  if (!window.kbfProductVariantUI && typeof subscribe === 'function') {
    window.kbfProductVariantUI = true;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html } }) => {
      const product = document.getElementById(`MainProduct-${sectionId}`);
      if (!product?.hasAttribute('data-kbf-product')) return;
      const source = html.querySelector('[data-kbf-product-image]');
      const target = product.querySelector('[data-kbf-product-image]');
      if (source && target) { target.innerHTML = source.innerHTML; target.className = source.className; }
      html.querySelectorAll('.kbf-thumb').forEach((t) => {
        const own = product.querySelector(`.kbf-thumb[data-media-id="${t.dataset.mediaId}"]`);
        if (own) own.setAttribute('aria-pressed', t.getAttribute('aria-pressed'));
      });
      if (typeof product.setQuantityBoundries === 'function') product.setQuantityBoundries();
      const button = product.querySelector('[name="add"]');
      if (button && !button.disabled) {
        const span = button.querySelector('span');
        if (span) span.textContent = 'Add to bag';
      }
    });
  }
})();
